import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import { Col } from "react-bootstrap";
import ChargeDetailChargeSection from "./chargeDetailChargeSection";
import ChargeDetailOrderSection from "./chargeDetailOrderSection";
import ChargeDetailContactSection from "./chargeDetailContactSection";
import ChargeDetailVehicleSection from "./chargeDetailVehicleSection";

export const ChargeDetailInfoView: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return (
      <LoaderOverlay loading={true}>
        <div style={{ minHeight: 200 }}></div>
      </LoaderOverlay>
    );
  }

  return (
    <div className="d-flex">
      <Col className="p-0">
        <Col lg={12} className="pr-3 pl-0">
          <ChargeDetailOrderSection vm={vm} />
        </Col>
        <Col lg={12} className="pr-3 pl-0">
          <ChargeDetailContactSection vm={vm} />
        </Col>
      </Col>
      <Col className="p-0">
        <Col lg={12} className="pl-3 pr-0">
          <ChargeDetailChargeSection vm={vm} />
        </Col>
        <Col lg={12} className="pl-3 pr-0">
          <ChargeDetailVehicleSection vm={vm} />
        </Col>
      </Col>
    </div>
  );
});

registerView(ChargeDetailInfoView, ChargeDetailInfoViewModel);
